import {stage} from './stage';

type ConfigShape = {
    [key in 'prod' | 'test' | 'dev' | 'ide']: {
        enabled: boolean;
        policyStoreId: string;
        region: string;
    };
};

const config: ConfigShape = {
    prod: {
        enabled: true,
        policyStoreId: '2K2hB4CCdutW1X2XQut1pE',
        region: 'us-west-2',
    },
    test: {
        enabled: true,
        policyStoreId: 'QvMchBBGvRvFQBhFV7qmSM',
        region: 'us-west-2',
    },
    dev: {
        enabled: true,
        policyStoreId: 'Jkay1dUCCTnuZeq6FfQFvB',
        region: 'us-west-2',
    },
    ide: {
        enabled: true,
        policyStoreId: 'Jkay1dUCCTnuZeq6FfQFvB',
        region: 'us-west-2',
    },
};

export default config[stage];
